module.exports = __webpack_public_path__ + "static/exterior1-71d2463a71dcca3585a7d7ccc2398d95.jpg";